export { default } from './GlobalFeed'
